import { render, staticRenderFns } from "./NoContent.vue?vue&type=template&id=7028c1c7&scoped=true"
import script from "./noContent.ts?vue&type=script&lang=ts&external"
export * from "./noContent.ts?vue&type=script&lang=ts&external"
import style0 from "./NoContent.vue?vue&type=style&index=0&id=7028c1c7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7028c1c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7028c1c7')) {
      api.createRecord('7028c1c7', component.options)
    } else {
      api.reload('7028c1c7', component.options)
    }
    module.hot.accept("./NoContent.vue?vue&type=template&id=7028c1c7&scoped=true", function () {
      api.rerender('7028c1c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/client/team-requests/no-content/NoContent.vue"
export default component.exports